import { z } from "zod";

const externalAccessTypes = ["apiKey", "oauth"] as const;
export const externalAccessTypeSchema = z.enum(externalAccessTypes);
export type ExternalAccessType = z.infer<typeof externalAccessTypeSchema>;
